// import { DisplayEventsEventNo } from '../@types/exhibition'
import { accessToken, client, userClient } from './auth'
import { isMobile, isIOS } from 'react-device-detect'

/** 전시 카테고리 가져오기 */
export async function getSections() {
  return await client.get(`/display/sections`)
}

/** 전시 카테고리 디테일 */
export async function getSectionsDetail(sectionNo: string) {
  if (accessToken) {
    return await userClient.get(`/display/sections/${sectionNo}`)
  } else {
    return await client.get(`/display/sections/${sectionNo}`)
  }
}

/** 전시 카테고리 품절 디테일 */
export async function getSectionsDetailSoldout(sectionNo: string) {
  if (accessToken) {
    return await userClient.get(`/display/sections/${sectionNo}?soldout=true`)
  } else {
    return await client.get(`/display/sections/${sectionNo}?soldout=true`)
  }
}

/** 전시 카테고리 디테일 */
export async function getSectionsDetailSale(sectionNo: string) {
  if (accessToken) {
    return await userClient.get(`/display/sections/${sectionNo}?by=POPULAR`)
  } else {
    return await client.get(`/display/sections/${sectionNo}?by=POPULAR`)
  }
}

/** 전시 카테고리 디테일 정렬 만들기 */
export async function getSectionsDetailKeywordVer1(sectionNo: any, keyword: string, page: number = 1) {
  const searchParams = new URLSearchParams({
    by: keyword,
    soldout: 'true',
    pageNumber: `${page}`,
    pageSize: '30',
    direction: 'DESC',
    saleStatus: 'ONSALE',
    hasTotalCount: 'true',
    hasOptionValues: 'false',
    includeStopProduct: 'false',
  })

  if (accessToken) {
    return await userClient.get(`/display/sections/${sectionNo}?${searchParams.toString()}`, {
      headers: { Version: '1.1' },
    })
  } else {
    return await client.get(`/display/sections/${sectionNo}?${searchParams.toString()}`, {
      headers: { Version: '1.1' },
    })
  }
}

export async function getSectionsDetailKeyword(sectionNo: any, keyword: string) {
  const searchParams = new URLSearchParams({
    by: keyword,
    soldout: 'true',
    pageNumber: '1',
    pageSize: '30',
    direction: 'DESC',
    saleStatus: 'ONSALE',
    hasTotalCount: 'false',
    hasOptionValues: 'false',
    includeStopProduct: 'false',
  })

  const platform = isIOS ? 'IOS' : isMobile ? 'MOBILE_WEB' : 'PC'

  if (accessToken) {
    return await userClient.get(`/display/sections/${sectionNo}?${searchParams.toString()}`, {
      headers: { Version: '2.0', platform },
    })
  } else {
    return await client.get(`/display/sections/${sectionNo}?${searchParams.toString()}`, {
      headers: { Version: '2.0', platform },
    })
  }
}

/** 기획전 */
export async function getEvents(keyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/display/events?page.number=1&page.size=50&keywordInfo.value=${keyword}&keywordInfo.type=TAG&progressStatus=ING`,
      { headers: { Version: '2.0' } }
    )
  } else {
    return await client.get(
      `/display/events?page.number=1&page.size=50&keywordInfo.value=${keyword}&keywordInfo.type=TAG&progressStatus=ING`,
      { headers: { Version: '2.0' } }
    )
  }
}

/** 기획전 */
export async function getKeywordEvents(keyword: string, status: string) {
  if (accessToken) {
    return await userClient.get(
      `/display/events/search-by-progress?&keyword=${keyword}&keywordInfo.type=TAG&progressStatus=${status}`
    )
  } else {
    return await client.get(
      `/display/events/search-by-progress?&keyword=${keyword}&keywordInfo.type=TAG&progressStatus=${status}`
    )
  }
}

/** 기획전 조회*/
export async function getAllEventList(status: string) {
  if (accessToken) {
    return await userClient.get(`/display/events?progressStatus=${status}`)
  } else {
    return await client.get(`/display/events?progressStatus=${status}`)
  }
}
export async function getAllEventSearch(status: string, page: number) {
  if (accessToken) {
    return await userClient.get(`/display/events?page.number=${page}&page.size=10&progressStatus=${status}`, {
      headers: { Version: '2.0' },
    })
  } else {
    return await client.get(`/display/events?page.number=${page}&page.size=10&progressStatus=${status}`, {
      headers: { Version: '2.0' },
    })
  }
}

/** 기획전 상세 */
export async function getEventDetail(eventNo: string | number, orderKeyword: string) {
  if (accessToken) {
    return await userClient.get(`/display/events/${eventNo}?order=${orderKeyword}&soldout=true`)
  } else {
    return await client.get(`/display/events/${eventNo}?order=${orderKeyword}&soldout=true`)
  }
}

/** 이벤트 상세 */
export async function getEventsDetail(eventNo: string) {
  if (accessToken) {
    return await userClient.get(`/display/events/${eventNo}`)
  } else {
    return await client.get(`/display/events/${eventNo}`)
  }
}

/** 상품평 게시판 목록 조회하기 */
export async function getReviewBoard() {
  return await client.get(
    `/reviews/boards?sorting.sortCriterion=REGISTER_YMDT&sorting.ordering=DESC&boardType=ALL&pageNumber=1`
  )
}

/** 상품평 게시판 목록 크게 조회하기 */
export async function getReviewBoards() {
  return await client.get(
    `/reviews/boards/reviewed-products?sorting.sortCriterion=REGISTER_YMDT&sorting.ordering=DESC&boardType=ALL&pageNumber=1`
  )
}

/** 관련 상품 정보조회 */
export async function getRelatedProduct(productNo: number) {
  if (!productNo) return null
  return await userClient.get(`/products/${productNo}/related-products`)
}

/** 팝업 조회 */
export async function getPopups() {
  return await client.get(`/display/popups`)
}

/** 카테고리 상품평 목록 */
export async function getCategoryProductReview(categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/category/product-reviews?categoryDepth=2&categoryNo=${categoryNo}&order.by=REGISTER_YMDT&order.direction=DESC&pageNumber=1&pageSize=20`
    )
  } else {
    return await client.get(
      `/category/product-reviews?categoryDepth=2&categoryNo=${categoryNo}&order.by=REGISTER_YMDT&order.direction=DESC&pageNumber=1&pageSize=20`
    )
  }
}

/** 배너 조회 */
export async function getMobileBannerId() {
  return await client.get(`/display/banners/id/mobile`)
}

/** 배너 조회pc */
export async function getPcBannerId() {
  return await client.get(`/display/banners/id/pcbanner`)
}

/** 배너 조회PC */
export async function getPcBannerCode() {
  return await client.get(`/display/banners/003`)
}

/** 상품 카테고리 넘버로 조회 */
export async function getCategorySearch(orderKeyword: string, page: number, categoryNo: number, pageSize: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.totalReviewCount=true&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}&pageSize=${pageSize}`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.totalReviewCount=true&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}&pageSize=${pageSize}`
    )
  }
}

/** 상품 카테고리 정렬 */
export async function getSortCategorySearch(orderKeyword: string, page: number, categoryNo: number, sort: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&filter.totalReviewCount=true&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&filter.totalReviewCount=true&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

/** 상품 키워드로 검색 */
export async function getKeywordSearch(orderKeyword: string, page: number, keyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=false&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageSize=500`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=false&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageSize=500`
    )
  }
}

/** 많이 팔린 상품 */
export async function getPopSaleCategorySearch(orderKeyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=false&excludeCategoryNos=787334&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=1&pageSize=4`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=false&excludeCategoryNos=787334&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=1&pageSize=4`
    )
  }
}

/** 상품 카테고리 정렬 */
export async function getSortCategoryHomeSearch(orderKeyword: string, page: number, categoryNo: number, sort: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&pageSize=4&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&pageSize=4&filter.soldout=false&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}
